<h2 class="headline">{{ headline() }}</h2>
